
import { Factcheck, FactcheckFilter } from "@/types";
import { Component, Vue, Watch } from "vue-property-decorator";

import * as FactcheckServices from '@/services/FactCheckService'
import { FactcheckIntegrationPublicationType } from '@/types'
import { ROOT_ACTIONS } from "@/store/actions";
import { formatDistance } from 'date-fns'

import { nlBE } from "date-fns/locale";
import { useDebounceFn } from "@vueuse/core";

@Component
export default class EFCSN extends Vue {
    factchecks: Factcheck[] = []
    publishedArticles: Array<{ factcheck: string, external: string }> = []
    query = ''

    async mounted() {
        await this.getFactchecks()

        const published = await FactcheckServices.ListAllPublications();
        this.publishedArticles = published.filter(e => e.integrationType === FactcheckIntegrationPublicationType.EFCSN).map(x => {
            return {
                factcheck: x.FactcheckId,
                external: x.externalId
            }
        })
    }

    dialog = false
    error = false
    errorMessage = ''
    selectedId = ''
    loading = false
    loadingFactchecks = false

    async publishToEfcsn(factcheckId?: string) {
        if (factcheckId) {
            this.selectedId = factcheckId
            this.dialog = true
        }
    }

    async getFactchecks() {
        this.loadingFactchecks = true
        this.factchecks = await FactcheckServices.GetAllFactChecks({
            partners: ['KNACK', 'VRT', 'FACTCHECK_VLAANDEREN'],
            query: this.query.length > 0 ? this.query : undefined,
        } as FactcheckFilter, 25, 0)
        this.loadingFactchecks = false
    }


    debouncedArticleFetch = useDebounceFn(async () => {
        await this.getFactchecks();
    }, 500)

    @Watch('query')
    async onQueryChange() {
        await this.debouncedArticleFetch()
    }

    async submit() {
        try {
            this.loading = true
            const res = await FactcheckServices.CreatePublication(this.selectedId, FactcheckIntegrationPublicationType.EFCSN);
            this.$store.dispatch(ROOT_ACTIONS.TOGGLE_NOTIFICATION, {
                color: 'success',
                text: 'Factcheck gepubliceerd naar EFCSN'
            })
            this.publishedArticles.push({
                factcheck: this.selectedId,
                external: res.externalId
            })
        } catch (error: any) {
            console.error(error)
            this.error = true
            this.errorMessage = error.response.data
        } finally {
            this.loading = false
            this.dialog = false
        }
    }

    get list() {
        return this.factchecks.map(x => ({
            id: x.id,
            title: x.title,
            partner: x.Claim?.ClaimReviews[0].Partner?.name,
            sortDate: formatDistance(new Date(x.sortDate), new Date(), {
                addSuffix: true,
                locale: nlBE
            }),
            published: this.publishedArticles.map(e => e.factcheck).includes(x.id!)
        }))
    }

    openExternal(id: string | undefined) {
        const externalId = this.publishedArticles.find(x => x.factcheck === id)?.external
        if (externalId) {
            window.open(`https://backoffice.elections24.efcsn.com/app/data/articles/edit?id=${externalId}`, '_blank')
        }
    }
}
